import { Site } from '@/core/entities';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	List,
	ListItem,
	ListItemProps,
	styled,
	LinkProps,
	ListItemText,
	ListItemTextProps,
	Box,
} from '@mui/material';
import { FunctionComponent, ReactElement } from 'react';
import { Link } from 'react-router-dom';

const UserSitesListItem = styled(ListItem)<ListItemProps>(() => ({
	padding: 0,
}));

const UserSitesListItemText = styled(ListItemText)<ListItemTextProps>(({ theme }) => ({
	paddingBottom: '0.25rem',
	margin: 0,
	'&:hover': {
		backgroundColor: theme.palette.background.default,
	},
}));

const UserSitesLink = styled(Link)<LinkProps>(() => ({
	display: 'inline-block',
	width: '100%',
	textDecoration: 'none',
	color: 'inherit',
	padding: '0.5rem 0',
}));

interface UserSitesListDialogProps {
	open: boolean;
	onClose: () => void;
	sites?: Site[];
	user?: string;
	customerId?: string;
}

const UserSitesListDialog: FunctionComponent<UserSitesListDialogProps> = ({
	open,
	onClose,
	sites,
	user,
	customerId,
}): ReactElement => (
	<Dialog
		open={open}
		onClose={onClose}
		fullWidth
		maxWidth="xs"
		PaperProps={{ sx: { maxHeight: '460px' } }}
	>
		<DialogTitle>{`Sites for ${user || ''}`}</DialogTitle>
		<DialogContent>
			{sites && (
				<List>
					{sites?.map((site) => (
						<Box component="div" key={site.id}>
							<UserSitesListItem>
								<UserSitesListItemText>
									{customerId && (
										<UserSitesLink to={`/customers/${customerId}/sites/${site.id}`}>
											{site.name}
										</UserSitesLink>
									)}
								</UserSitesListItemText>
							</UserSitesListItem>
							<Divider />
						</Box>
					))}
				</List>
			)}
		</DialogContent>
		<DialogActions>
			<Button onClick={onClose}>Cancel</Button>
		</DialogActions>
	</Dialog>
);

export default UserSitesListDialog;
